import React from 'react'
import { Button } from 'antd'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error capturado por ErrorBoundary:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="vh-100 d-flex flex-column align-items-center justify-content-center gap-4">
          <h1 className="fs-4 m-0">¡Ups! Algo salió mal - 500</h1>
          <div className="d-flex flex-column align-items-center gap-4">
            <Button
              type="ghost"
              icon={<i className="fas fa-home mr-2" />}
              onClick={this.handleReload}
            >
              Recargar la página
            </Button>

            <span>
              o visita <a href="https://accordttechnology.com" target="_blank" rel="noopener noreferrer">
                ACCORD Technology
              </a>
            </span>
          </div>
        </main>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary